import { NgModule } from "@angular/core";
import { FeatherModule } from "angular-feather";
import {
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  AtSign,
  Award,
  BarChart2,
  Bell,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  Code,
  Codesandbox,
  Copy,
  CornerUpLeft,
  CreditCard,
  DollarSign,
  Edit,
  Edit2,
  Edit3,
  ExternalLink,
  Feather,
  Flag,
  FolderMinus,
  FolderPlus,
  Gift,
  Heart,
  HelpCircle,
  Home,
  Image,
  Info,
  Key,
  Link,
  Link2,
  List,
  Mail,
  MessageSquare,
  Monitor,
  MoreHorizontal,
  MoreVertical,
  Percent,
  Plus,
  PlusCircle,
  Power,
  RefreshCw,
  Repeat,
  RotateCw,
  Search,
  Send,
  Settings,
  Share,
  Share2,
  ShoppingBag,
  ShoppingCart,
  Shield,
  Cpu,
  UserCheck,
  Smile,
  Tag,
  ThumbsUp,
  Trash2,
  TrendingUp,
  Twitter,
  Server,
  User,
  UserPlus,
  Users,
  UserX,
  Video,
  X,
  XSquare,
} from "angular-feather/icons";
import {
  BellNotification,
  Bitclout,
  Card,
  Coin,
  CreatorCoin,
  Deso,
  Diamond,
  Frame,
  Gem,
  LandingBullet1,
  LandingBullet2,
  LandingBullet3,
  Lock,
  Lock2,
  MessageNotification,
  MultipleNfts,
  Quote,
  SingleNft,
} from "src/assets/img/feather";

const icons = {
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  AtSign,
  Award,
  BarChart2,
  Bell,
  BellNotification,
  Bitclout,
  BitcloutCircle: CreatorCoin,
  Card,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  ChevronUp,
  Clock,
  Code,
  Codesandbox,
  Coin,
  Copy,
  CornerUpLeft,
  CreditCard,
  CreatorCoin,
  Deso,
  DollarSign,
  Diamond,
  Edit,
  ExternalLink,
  Feather,
  Flag,
  FolderMinus,
  FolderPlus,
  Frame,
  Gem,
  Gift,
  Heart,
  HelpCircle,
  Home,
  Image,
  Info,
  Key,
  LandingBullet1,
  LandingBullet2,
  LandingBullet3,
  Link,
  Link2,
  List,
  Lock,
  Lock2,
  Mail,
  MessageNotification,
  MessageSquare,
  Monitor,
  MoreHorizontal,
  MoreVertical,
  MultipleNfts,
  Percent,
  Power,
  Plus,
  PlusCircle,
  Quote,
  RefreshCw,
  Repeat,
  RotateCw,
  Search,
  Send,
  Settings,
  Share,
  Share2,
  ShoppingBag,
  ShoppingCart,
  Shield,
  Cpu,
  UserCheck,
  SingleNft,
  Smile,
  Tag,
  ThumbsUp,
  Trash2,
  TrendingUp,
  User,
  Users,
  UserPlus,
  UserX,
  Video,
  X,
  XSquare,
  Edit2,
  Edit3,
  Twitter,
  Server,
  MyVote: CheckCircle,
};

@NgModule({
  imports: [FeatherModule.pick(icons)],
  exports: [FeatherModule],
})
export class IconsModule {}
